import React, {Component} from 'react';

import { Row, Col, Button, Card, CardHeader, CardFooter, CardBody, Form, FormGroup, Label, Input, Alert } from 'reactstrap';

import * as vars from '../../constants/constants';

import { console_log, jsUcfirst, formatDate } from "../../utils/helper";

class AddCountryLanguage extends Component {
    render() {
        return (
            <div className="addcountrylanguage animated fadeIn">
                <Row>
                    <Col xs="12" md="12">
                        <Card>
                            <CardHeader>
                                <strong>Edit Country</strong>
                            </CardHeader>
                            <CardBody>
                                <Form action="" method="post" encType="multipart/form-data" className="form-horizontal">
                                    <FormGroup row>
                                        <Col xs="12" md="4">
                                            <Label htmlFor="countryname">Country Name</Label>
                                            <Input type="select" id="countryname" name="countryname" placeholder="Country Name" disabled>
                                                <option value={0}>India</option>
                                            </Input>
                                        </Col>
                                        <Col xs="12" md="4">
                                            <Label htmlFor="language">Language</Label>
                                            <Input type="select" name="language" id="language" multiple disabled>
                                                <option value={0}>English</option>
                                                <option value={1}>Marathi</option>
                                            </Input>
                                        </Col>
                                    </FormGroup>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col xs="12" md="12">
                        <Card>
                            <CardHeader>
                                <strong>Add Sub Domain and Details</strong>
                            </CardHeader>
                            <CardBody>
                                <Form action="" method="post" encType="multipart/form-data" className="form-horizontal">
                                    <FormGroup row>
                                        <Col xs="12" md="4">
                                            <Label htmlFor="subdomainname">Sub Domain Name</Label>
                                            <Input type="text" id="subdomainname" name="subdomainname" />
                                        </Col>
                                        <Col xs="12" md="4">
                                            <Label htmlFor="selectdomain">Domain URL</Label>
                                            <Input type="select" name="selectdomain" id="selectdomain">
                                                <option value={0}>Select Domain</option>
                                            </Input>
                                        </Col>
                                        <Col xs="12" md="4">
                                            <Label htmlFor="url">URL</Label>
                                            <Input type="text" id="url" name="url" disabled/>
                                        </Col>
                                    </FormGroup>
                                    <Alert color="danger"></Alert>
                                </Form>
                            </CardBody>
                            <CardFooter className="card-footer-align-right">
                                <Button type="submit" color="primary"><i className="fa fa-times"></i> Cancel</Button>{' '}
                                <Button type="submit" color="success"><i className="fa fa-check"></i> Save</Button>
                            </CardFooter>
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default AddCountryLanguage;


// WEBPACK FOOTER //
// ./src/components/Country/AddCountryLanguage.js